import { put, select } from 'redux-saga/effects'
import { delay } from 'redux-saga';
import {matchPath} from "react-router";
import {history} from "state/history";
import logger from "lib/log";

import * as teachersActions from "state/teachers/actions";
import * as teachersSelectors from "state/teachers/selectors";
import * as schoolMoneyActions from "state/school_money/actions";
import * as schoolMoneySelectors from "state/school_money/selectors";
import * as appActions from "state/app/actions";

// candiate for implementing delegate goBack sagas in state/teachers/sagas etc
export default function* goBackSaga(action) {

  const teachersPathMatch    = matchPath(action.payload.pathname, {path: "/teachers/", exact:false});
  const schoolMoneyPathMatch = matchPath(action.payload.pathname, {path: "/school_money/", exact:false});
  const appPathMatch         = matchPath(action.payload.pathname, {path: "/", exact:false});

  if (teachersPathMatch !== null) {
    // if the guide is currently open, close the guide as a back action
    const isGuideOpen = yield select(teachersSelectors.isGuideOpen);
    if (isGuideOpen) {
      logger.info("goBack: T2P/guide is open, closing...")
      yield put( teachersActions.closeGuide() )
      return;
    }
  } else if (schoolMoneyPathMatch !== null) {
    // First, if the guide is open, close that
    const isGuideOpen = yield select(schoolMoneySelectors.isGuideOpen);
    if (isGuideOpen) {
      logger.info("goBack: SM/guide is open, closing...")
      yield put( schoolMoneyActions.closeGuide() )
      return;
    }
    // Below that, the checkout could be open, so close that
    const isCheckoutWindowOpen = yield select(schoolMoneySelectors.isCheckoutWindowOpen);
    if( isCheckoutWindowOpen ) {
      logger.info("goBack: SM/isCheckoutOpen is open, closing...")
      yield put( schoolMoneyActions.closeCheckout() );
      return;
    }
  } else if (appPathMatch !== null) {
    // do app back actions
  }
  
  // Unmatched, or no action
  // We should attempt to push the user back by one history step
  // There's no way of determining whether it worked or didnt, so we have to do a timed-best-guess
  const previousLocation = window.location.href;
  history.goBack();

  // Wait in the hope that history will resolve
  yield delay(100);

  // location is the same after delay, likely at the bottom of the history stack
  if( window.location.href === previousLocation ) {
    yield put( appActions.closeApplication() );
    return;
  } else {
    // Do nothing. goBack was successful.
  }
}



// WEBPACK FOOTER //
// ./src/state/app/sagas/goBack.js